export const loadingConf = state => state.admissionReducer.note.loadingConf

export const isSuccess = state => state.admissionReducer.note.isSuccess

export const notes = state => state.admissionReducer.note.notes

export const notesLength = state => state.admissionReducer.note.notesLength

export const currentNotesPage = state => state.admissionReducer.note.currentNotesPage

export const history = state => state.admissionReducer.note.history

export const historyLength = state => state.admissionReducer.note.historyLength

export const options = state => state.admissionReducer.note.options

export const permissions = state => state.admissionReducer.note.permissions

export const isOpenHistory = state => state.admissionReducer.note.isOpenHistory
